import styled from "styled-components";

export const DatePickerWrapper = styled.div`
  width: 100%;
`;

export const DatePickerLabelWrapper = styled.div`
  
`;

